/**
 * "or continue with" divider — hairline + centered label.
 * Used between primary (email) and secondary (Google) actions.
 */
interface DividerProps {
  children: React.ReactNode;
}

export function Divider({ children }: DividerProps) {
  return (
    <div
      // a11y: this is decorative; the screen reader doesn't need the rules
      role="separator"
      aria-orientation="horizontal"
      className="flex items-center gap-3 text-[11px] uppercase tracking-[0.16em] text-[var(--color-ink-40)] font-semibold"
    >
      <span className="h-px flex-1 bg-[var(--color-ink-08)]" />
      <span>{children}</span>
      <span className="h-px flex-1 bg-[var(--color-ink-08)]" />
    </div>
  );
}

export default Divider;
